/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'waf';
const componentName = 'waf-policy-list-page';
const prefix = `${moduleName}.${componentName}`;

export const successfulCloneHeader = `${prefix}.successfulCloneHeader`;
export const successfulCloneMessage = `${prefix}.successfulCloneMessage`;

export const ENGLISH = {
    [successfulCloneHeader]: 'Successfully cloned',
    [successfulCloneMessage]: 'The policy should appear in the table shortly.',
};
